module.exports = __webpack_public_path__ + "static/media/acab4df9ed811d23d05318f451977986.b41528d7.jpg";